<template>
  <div class="multi-field" :class="{ 'has-error': !!error }">
    <slot :attributes="{
      class: error ? 'input-error' : undefined,
      'aria-invalid': error ? 'true' : undefined,
      'aria-describedby': error ? errorId : undefined,
    }" />
    <template v-if="error">
      <ErrorTooltip :text="error" always-visible focusable :tooltip-id="errorId + '-popup'" />
      <span :id="errorId" class="multi-error-description">{{ error }}</span>
    </template>
  </div>
</template>

<script>
import ErrorTooltip from './ErrorTooltip.vue';

export default {
  components: { ErrorTooltip },
  props: {
    error: { type: String, default: '' },
    errorId: { type: String, required: true },
  },
};
</script>

<style scoped>
.multi-field { position: relative; }
.multi-field.has-error :deep(input), .multi-field.has-error :deep(select) { border-color: #bd1826; padding-right: 27px; }
.multi-field :deep(.error-tooltip-container) { position: absolute; right: 6px; top: 6px; margin: 0; line-height: 1; }
.multi-field :deep(.error-icon img) { width: 17px; height: 17px; background: transparent; }
.multi-field :deep(.error-tooltip-container:focus-visible) { outline: 2px solid #a71930; outline-offset: 2px; }
.multi-error-description { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip-path: inset(50%); white-space: nowrap; }
</style>
